<script lang="ts" setup>
defineOptions({
  name: 'CommonActivityTemplate2',
});

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <section class="common-component-activity-template-2 relative rounded-4 bg-transparent bg-contain bg-no-repeat">
    <div class="absolute left-10% right-10% top-20% line-clamp-3 color-hex-292929">{{ props.title }}</div>
  </section>
</template>

<style lang="scss" scoped>
.common-component-activity-template-2 {
  background-image: url(./assets/bg.png);
}
</style>
